import { render, staticRenderFns } from "./TrainingEventList.vue?vue&type=template&id=3350b374"
import script from "./TrainingEventList.vue?vue&type=script&lang=js"
export * from "./TrainingEventList.vue?vue&type=script&lang=js"
import style0 from "./TrainingEventList.vue?vue&type=style&index=0&id=3350b374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports